module.exports = __webpack_public_path__ + "img/3ROSEAPPLE.953afa5c.png";